import { render, staticRenderFns } from "./TaskPager.vue?vue&type=template&id=6b8fee92&"
import script from "./TaskPager.vue?vue&type=script&lang=ts&"
export * from "./TaskPager.vue?vue&type=script&lang=ts&"
import style0 from "./TaskPager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports